import React from "react";
import TravelPermissionsSection from "../components/TravelPermissionsSection";

export default function TravelTab({
    meta,
}) {
    return (
        <TravelPermissionsSection
            meta={meta}
        />
    );
}